import { useTranslation } from '../i18n';
import './ProgressBar.css';

interface Props {
  confirmed: number;
  requiredTotal: number;
}

/** "X of Y required fields confirmed" with a visible fill bar AND numeric
 *  text so color-impaired users get the full signal. */
export function ProgressBar({ confirmed, requiredTotal }: Props) {
  const { t } = useTranslation();
  const safeTotal = Math.max(requiredTotal, 1);
  const pct = Math.min(100, Math.round((confirmed / safeTotal) * 100));
  const label = t('chat.progress', {
    confirmed,
    required_total: requiredTotal,
  });

  return (
    <div
      className="cf-progress"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={requiredTotal}
      aria-valuenow={confirmed}
      aria-label={label}
    >
      <div className="cf-progress__track" aria-hidden="true">
        <div className="cf-progress__fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="cf-progress__label">{label}</div>
    </div>
  );
}
